module.exports = __webpack_public_path__ + "img/CircleWhite.08dcaf7a.png";